import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import WagonWheelChart from './wagonWheelChart'
import ChartFilter from './chartFIlter'
import PlayerFilter from './wagonWheelChart/playerFilter'
import { useLazyQuery } from '@apollo/client'
import { GET_WAGON_WHEEL_DATA } from '@graphql/wagonWheel/wagonWheel.query'
import { getRun, getXaxis, renderNewCords } from '@shared/libs/wagonGraph'
import { pageLoading } from '@shared/libs/allLoader'
import NoData from '@shared/components/noData'

function WagonWheel({ matchDetail, inningData }) {
  const { aInning, oTeamScoreA, oTeamScoreB } = matchDetail || {}
  const teamAId = aInning?.[0]?.iBattingTeamId
  const teamA = teamAId === oTeamScoreA?.oTeam?._id ? oTeamScoreA?.oTeam : oTeamScoreB?.oTeam
  const teamB = teamA?._id === oTeamScoreA?.oTeam?._id ? oTeamScoreB?.oTeam : oTeamScoreA?.oTeam

  const [allData, setAllData] = useState([])

  const [playerData, setPlayerData] = useState(inningData?.find(i => i?.iBattingTeamId === teamA?._id))
  const [newData, setNewData] = useState([])
  const [runs, setRuns] = useState()
  const [typeWiseRun, setTypeWiseRun] = useState({})
  const [currentTeamId, setCurrentTeamId] = useState(teamA?._id)
  const [isData, setIsData] = useState(false)

  const tabs = [teamA, teamB]

  useEffect(() => {
    getWagonWheelData({
      variables: {
        input: {
          iMatchId: matchDetail?._id,
          nInningNumber: 1
        }
      }
    })
  }, [])

  // ? INPUT { !MATCH_ID , INNING_NUMBER, BATTERS, BOWLERS}
  const [getWagonWheelData, { loading }] = useLazyQuery(GET_WAGON_WHEEL_DATA, {
    onCompleted: d => {
      const { runs: data, isCoordinate } = d?.getWagonsData || {}
      if (!runs?.total && runs?.total !== 0) {
        setIsData(!!isCoordinate)
        handleData(data)
      } else {
        handleData(data)
      }
    }
  })

  // !HANDLE DATA TYPE WISE
  function handleData(d) {
    const getTypeCount = type => d?.types?.find(t => t?.type === type)?.count || 0

    const filterData = {
      '1s': getTypeCount('1s'),
      '2s': getTypeCount('2s'),
      '3s': getTypeCount('3s'),
      '4s': getTypeCount('4s'),
      '6s': getTypeCount('6s')
    }

    setTypeWiseRun(filterData)

    const { offSide, onSide, total } = d || {}
    setRuns({ offSide, onSide, total })

    const t = mapNewData(d?.types)
    setNewData(t)
    setAllData(t)
  }

  // !CHANGE X AND Y CORDS AS PER ENTITY CORDS
  function mapNewData(d) {
    const t = d?.map(d => {
      return {
        ...d,
        list: d?.list?.map(t => {
          const newCords = renderNewCords(getXaxis(t?.nXcord, getRun[d?.type]), t?.nYcord)
          return {
            x: newCords?.x,
            y: newCords?.y
          }
        })
      }
    })
    return t
  }

  // !TEAM CHANGE
  function handleTeam(id) {
    const inningNumber = id === teamA?._id ? 1 : id === teamB?._id ? 2 : null
    if (inningNumber !== null) {
      getWagonWheelData({
        variables: {
          input: {
            iMatchId: matchDetail?._id,
            nInningNumber: inningNumber
          }
        }
      })
    }
    setCurrentTeamId(id)
    const t = inningData?.find(i => i?.iBattingTeamId === id)
    setPlayerData(t)
  }

  // !FILTER DATA WITH BATTERS AND BOWLERS
  function handlePlayersData(batter, bowler) {
    const inningNumber =
      currentTeamId === teamA?._id ? (batter?.length === 0 ? 0 : 1) : currentTeamId === teamB?._id ? (batter?.length === 0 ? 0 : 2) : null
    if (batter?.length === 0 || inningNumber === 0) {
      setNewData([])
      setRuns({ onSide: 0, offSide: 0, total: 0 })
    }
    if (inningNumber !== null && inningNumber !== 0 && batter?.length > 0) {
      getWagonWheelData({
        variables: {
          input: {
            iMatchId: matchDetail?._id,
            nInningNumber: inningNumber,
            iBatterIds: batter,
            iBowlerId: bowler
          }
        }
      })
    }
  }

  return (
    <>
      {!runs?.total && runs?.total !== 0 && loading ? (
        pageLoading()
      ) : isData ? (
        <>
          <div className="common-box p-0 pt-2 ">
            <div className={`d-flex gap-2 ${styles.tabsContainer} `}>
              {tabs?.map((t, i) => {
                return (
                  <div key={i} className={`${styles.tab} ${currentTeamId === t?._id && styles.active}`} onClick={() => handleTeam(t?._id)}>
                    <div>{t?.sTitle}</div>
                  </div>
                )
              })}
            </div>

            <div className={`${styles.runsMobile} d-flex d-md-none py-2`}>
              <div className="d-flex gap-1 align-items-baseline">
                <span>Off Side: </span>
                <p>
                  {runs?.offSide}
                  <span className="mb-0 mx-1">runs</span>
                </p>
              </div>
              <span className={styles.divider} />
              <div className="d-flex gap-1 align-items-baseline">
                <span>On Side: </span>
                <p>
                  {runs?.onSide}
                  <span className="mb-0 mx-1">runs</span>
                </p>
              </div>
            </div>

            <div className={styles.mainContainer}>
              <div className={styles.runs}>
                <h6>Off Side:</h6>
                <p className="text-3xl">
                  {runs?.offSide}
                  <span className="mb-0 mx-1 text-lg font-theme">runs</span>
                </p>
              </div>

              {/* WAGON WHEEL */}
              {loading ? (
                <div style={{ minWidth: '400px', minHeight: '400px' }} className="d-flex justify-content-center">
                  {pageLoading()}
                </div>
              ) : (
                <WagonWheelChart data={runs?.total > 0 ? newData : []} />
              )}

              <div className={styles.runs}>
                <h6>On Side:</h6>
                <p>
                  {runs?.onSide}
                  <span className="mx-1">runs</span>
                </p>
              </div>
            </div>

            <ChartFilter
              currentTeamId={currentTeamId}
              allData={allData}
              setNewData={setNewData}
              typeWiseRun={typeWiseRun}
              runs={runs}
            />
          </div>
          <PlayerFilter
            setTypeWiseRun={setTypeWiseRun}
            handlePlayersData={handlePlayersData}
            matchDetail={matchDetail}
            playerData={playerData}
            currentTeamId={currentTeamId}
          />
        </>
      ) : (
        <NoData />
      )}
    </>
  )
}

WagonWheel.propTypes = {
  matchDetail: PropTypes.object,
  inningData: PropTypes.array
}

export default WagonWheel
